// extracted by mini-css-extract-plugin
export default {"section-1-container":"Section1_section-1-container__yy9Ej","text-on-image":"Section1_text-on-image__cYuvZ"};